import React from "react";
import {
  Drawer,
  Box,
  IconButton,
  Stack,
  Typography,
  ButtonBase,
  Fade,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ANCHORS, HEADER_HEIGHT } from "../utils/anchors";

function scrollToId(id, onClose) {
  const el = document.getElementById(id);
  if (!el) return;

  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
  window.scrollTo({ top, behavior: "smooth" });
  if (onClose) onClose();
}

export default function MobileMenuDrawer({ open, onClose }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      // deixa a transição do Drawer mais "suave"
      transitionDuration={{ enter: 420, exit: 280 }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 520, md: 620 },
          maxWidth: "100vw",
          bgcolor: "rgba(0,0,0,0.86)",
          color: "var(--branco)",
          borderLeft: "1px solid rgba(255,255,255,0.10)",
          backdropFilter: "blur(14px)",
          backgroundImage:
            "radial-gradient(900px 700px at 30% 20%, rgba(172,201,14,0.08), transparent 60%)",
        },
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            bgcolor: "rgba(0,0,0,0.62)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      {/* Conteúdo animado por dentro */}
      <Fade in={open} timeout={250}>
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* TOP BAR */}
          <Box
            sx={{
              height: HEADER_HEIGHT,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: { xs: 2, md: 3 },
              borderBottom: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <Stack direction="row" spacing={1.2} alignItems="center">
              <Typography sx={{ fontWeight: 1000, letterSpacing: "0.04em", color: "var(--verdeClaro)" }}>
                MENU
              </Typography>
            </Stack>

            <IconButton
              onClick={onClose}
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                border: "1px solid rgba(255,255,255,0.12)",
                color: "var(--branco)",
                bgcolor: "rgba(255,255,255,0.04)",
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.07)",
                  borderColor: "rgba(172,201,14,0.30)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* BODY */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "stretch",
              justifyContent: "space-between",
              gap: 3,
              px: { xs: 2, md: 3 },
              py: { xs: 3.5, md: 5 },
            }}
          >
            {/* Lista (anima entrando) */}
            <Slide
              direction="left"
              in={open}
              timeout={{ enter: 520, exit: 200 }}
              easing={{
                enter: "cubic-bezier(0.16, 1, 0.3, 1)", // bem suave
                exit: "cubic-bezier(0.4, 0, 1, 1)",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <Stack spacing={2.4}>
                  {ANCHORS.map((a) => (
                    <ButtonBase
                      key={a.id}
                      onClick={() => scrollToId(a.id, onClose)}
                      sx={{
                        width: "100%",
                        justifyContent: "flex-start",
                        textAlign: "left",
                        borderRadius: 0,
                        py: 1.2,
                        px: 1.2,
                        transition: "all .15s ease",
                        borderLeft: "4px solid transparent",
                        paddingLeft: "0px",
                        "&:hover": {
                          color: "var(--verdeClaro)",
                          transform: "scale(1.03)",
                          borderLeft: "4px solid var(--verdeClaro)",
                          paddingLeft: "15px",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 1000,
                          letterSpacing: "-0.02em",
                          textTransform: "uppercase",
                          fontSize: { xs: 28, sm: 34, md: 40 },
                          lineHeight: 1.05,
                          color: "var(--branco)",
                        }}
                      >
                        {a.label}
                      </Typography>
                    </ButtonBase>
                  ))}
                </Stack>

                <Typography
                  sx={{
                    mt: { xs: 4, md: 6 },
                    color: "rgba(255,255,255,0.55)",
                    fontSize: 12,
                  }}
                >
                  Lusco Produtora • Onde a luz começa
                </Typography>
              </Box>
            </Slide>
          </Box>
        </Box>
      </Fade>
    </Drawer>
  );
}